import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { MotionWrapper } from 'utils';

const ProductDetail = () => {
	return (
		<>
			<MotionWrapper p={2} spacing={1}>
				<Skeleton variant="rounded" animation="wave" height="200px" />
				<Typography variant="h3">
					<Skeleton animation="wave" />
				</Typography>
				<Stack direction="row" spacing={2} pb={2}>
					<Skeleton variant="rounded" animation="wave" width="30%" />
					<Skeleton variant="rounded" animation="wave" width="15%" />
				</Stack>
				<Box
					p={2}
					m={2}
					sx={{
						borderRadius: '8px',
						backgroundColor: 'white',
					}}
				>
					<Stack direction="column" spacing={2}>
						<Typography variant="subtitle2">
							<Skeleton animation="wave" />
						</Typography>
						<Typography variant="subtitle2">
							<Skeleton animation="wave" />
						</Typography>
					</Stack>
				</Box>
			</MotionWrapper>
		</>
	);
};

export default ProductDetail;
